export const CRMSteps = {
	ICD: { number: 6, complete: false },
	alarmSignals: { number: 8, complete: false },
	'session-note': { number: 13, complete: true },
};
